import { Button, Input } from '@innowise-group/mui-kit';
import { styled } from '@innowise-group/mui-kit';

export const FullInput = styled(Input)`
  &.MuiTextField-root {
    width: 100%;
  }
`;

export const PublishCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ButtonsSection = styled.div`
  display: flex;
  gap: 0.75rem;
  & > * {
    flex: 1;
  }
  margin-top: 1rem;
`;

export const GrayButton = styled(Button)`
  &.MuiButton-root.MuiButton-outlined {
    color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    border-color: ${({ theme }) => theme.palette.general.darkGrey[60]};
    transition: 0.2s;
  }
  &.MuiButton-root.MuiButton-outlined:hover {
    color: ${({ theme }) => theme.palette.general.darkGrey[80]};
    border-color: ${({ theme }) => theme.palette.general.darkGrey[80]};
  }
`;
